import React from 'react';
import {
  CircularProgressbar,
  buildStyles
} from "react-circular-progressbar";
import 'react-circular-progressbar/dist/styles.css';
import styled from 'styled-components'

const ProgressRoot = styled.div`
  width: 145px;
  height: 145px;
  margin: 3rem 1rem; 
  background-color: ${props => props.has_premium === true ? 'transparent' : '#F2F8F2'};
  filter: ${props => props.has_premium === true ? null : 'blur(7px)'};
  position: relative;
  @media (min-width: 992px) {
    width: 145px;
    height: 145px;
    margin: 0rem 2rem; 
  }
  .CircularProgressbar-text {
    transform: translate(0px, 5px);
  }
`

function ProgressCircle({ value, valueNumber, trailColor, pathColor, textColor, name, has_premium }) {
  return (
    <ProgressRoot has_premium={has_premium}>
      <CircularProgressbar
        value={Math.round(value)}
        text={valueNumber}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
        styles={
          buildStyles({
            transitionTimingFunction: 'ease',
            trailColor: trailColor,
            textColor: textColor,
            pathColor: pathColor,
            textSize: "22px",
          })}
      />
      <div className='d-flex justify-content-center flex-column py-2'>
        <span className='n-fs-7 n-lg-fs-6 neutral-charcoal fw-bold text-center' style={{ fontWeight: 900 }}>{name}</span>
        <span className='n-fs-7 n-lg-fs-6 neutral-charcoal fw-bold text-center'>kr/m<sup>3</sup> fub</span>
      </div>
    </ProgressRoot>
  )
}

export default ProgressCircle